@if(installationIds){
<div class="first-row">
  <div class="container-alarms">
    <app-general-status
      [installationIds]="installationIds"
    ></app-general-status>
    <app-alarms-history-chart
      [installationIds]="installationIds"
    ></app-alarms-history-chart>
  </div>

  <app-home-clock></app-home-clock>
  <app-map-google></app-map-google>
</div>

<div class="second-row">
  <app-current-info></app-current-info>
  <app-os-info></app-os-info>
</div>
}
